import DashboardComponentDto from "./DashboardComponentDto";

export default class DashboardDetailDto {

    Id: number;
    Name: string;
    Components: DashboardComponentDto[];

    constructor(id: number, name: string, components: DashboardComponentDto[]) {
        this.Id = id;
        this.Name = name;
        this.Components = components;
    }
}
